import { PMREMGenerator } from "three";
import { TypedCopNode } from "./_Base";
import { InputCloneMode } from "../../poly/InputCloneMode";
import { DataTextureController, DataTextureControllerBufferType } from "./utils/DataTextureController";
import { CopRendererController } from "./utils/RendererController";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { isBooleanTrue } from "../../../core/BooleanValue";
import { CubeUVReflectionMapping } from "three";
class EnvMapCopParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.useCameraRenderer = ParamConfig.BOOLEAN(0);
  }
}
const ParamsConfig = new EnvMapCopParamsConfig();
export class EnvMapCopNode extends TypedCopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "envMap";
  }
  initializeNode() {
    this.io.inputs.setCount(1);
    this.io.inputs.initInputsClonedState(InputCloneMode.NEVER);
  }
  async cook(input_contents) {
    const texture = input_contents[0];
    this._convertTextureToEnvMap(texture);
  }
  async _convertTextureToEnvMap(input_texture) {
    this._rendererController = this._rendererController || new CopRendererController(this);
    const renderer = await this._rendererController.waitForRenderer();
    if (renderer) {
      const pmremGenerator = new PMREMGenerator(renderer);
      const exrCubeRenderTarget = pmremGenerator.fromEquirectangular(input_texture);
      if (isBooleanTrue(this.pv.useCameraRenderer)) {
        this._setMapping(exrCubeRenderTarget.texture);
        this.setTexture(exrCubeRenderTarget.texture);
      } else {
        this._dataTextureController = this._dataTextureController || new DataTextureController(DataTextureControllerBufferType.Uint16Array);
        const texture = this._dataTextureController.from_render_target(renderer, exrCubeRenderTarget);
        this._setMapping(texture);
        this.setTexture(texture);
      }
    } else {
      this.states.error.set("no renderer found to convert the texture to an env map");
      this.cookController.endCook();
    }
  }
  _setMapping(texture) {
    texture.mapping = CubeUVReflectionMapping;
  }
}
